const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_DEVICES_INIT: "DEVICES_LIST/GET_DEVICES_INIT",
  GET_DEVICES_SUCCESS: "DEVICES_LIST/GET_DEVICES_SUCCESS",
  GET_DEVICES_FAILURE: "DEVICES_LIST/GET_DEVICES_FAILURE",
  GET_MORE_DEVICES_INIT: "DEVICES_LIST/GET_MORE_DEVICES_INIT",
  GET_MORE_DEVICES_SUCCESS: "DEVICES_LIST/GET_MORE_DEVICES_SUCCESS",
  GET_MORE_DEVICES_FAILURE: "DEVICES_LIST/GET_MORE_DEVICES_FAILURE",
};

export const initialState = {
  productsFetching: true,
  getMoreFetching: true,
  fechingError: false,
  serverRender: true,
  productsCards: [{
    labelPromo: '',
    image: '',
    name: '',
    href: '',
    labelSaving: '',
    prePriceLabel: '',
    calculatedDifferenceBetweenR2RAndFreePrice: '',
    isEquipment: '',
    offers: {
      libre: {
        title: '',
        finalPrice: '',
        currency: '',
        quote: '',
        finalPriceBeforeDiscounts: ''
      },
      r2r: {
        title: '',
        recurringPrice: '',
        currency: '',
        quote: '',
      },
      r2rAdditional: {
        title: '',
        recurringPrice: '',
        currency: '',
        quote: '',
      }
    },
    financing: {

    },
    bottomCardText: "",
    isRecom: '' //Customizer Card
  }],
  id: "moviles",
  filters: [],
  selectedFilters: [],
  totalNumberOfPages: 0,
  //pageIndex: 0,
  //pageSize: 39,
  pagination: {
    resultFrom: 0,
    resultLimit: 39
  },
  sort: "relevance",
  filtersApplied: 0,
  showRenewR2ROffersFilter: false,
  isBtl: false,
  hasToShowR2RRenovationOffers: false,
  showCollectivesOffersFilter: false,
};

export const actions = {
  initGetDevicesList: (data) => ({
    type: types.GET_DEVICES_INIT,
    data,
  }),
  initGetMoreDevicesList: (data) => ({
    type: types.GET_MORE_DEVICES_INIT,
    data,
  }),
  successGetDevicesList: (data) => ({
    type: types.GET_DEVICES_SUCCESS,
    payload: {
      data
    },
  }),
  failureGetDevicesList: () => ({
    type: types.GET_DEVICES_FAILURE,
  }),
};
const DevicesList = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      let { devicesList } = action.payload;
      return {
        ...state,
        ...devicesList,
      };
    }
    case types.GET_DEVICES_INIT: {
      return {
        ...state,
        productsFetching: true,
      };
    }
    case types.GET_DEVICES_SUCCESS: {
      const {
        data
      } = action.payload;

      return {
        ...state,
        ...data,
        productsFetching: false,
        getMoreFetching: false
      };
    }
    case types.GET_DEVICES_FAILURE: {
      return {
        ...state,
        productsFetching: false,
        fechingError: true,
      };
    }
    case types.GET_MORE_DEVICES_INIT: {
      return {
        ...state,
        getMoreFetching: true,
      };
    }
    default:
      return state;
  }
};

export default DevicesList;
